import Plaatjie from '@ubo/plaatjie'
import React from 'react'
import styled from 'styled-components'
import BoxDefault from './BoxDefault'
import ParseContent from '../shared/ParseContent'
import ButtonDefault from './ButtonDefault'

const Section = styled.section`
  max-width: 1024px;
  margin-inline: auto;
  padding-top: 3rem;

  @media (min-width: 992px) {
    padding-bottom: 6rem;
  }
`

const StyledBoxDefault = styled(BoxDefault)`
  background-color: #e5e5e5;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
  flex-grow: 1;
  aspect-ratio: 16 / 13;

  img {
    height: 70px;
    aspect-ratio: 1 / 1;
  }

  span {
    font-weight: 700;
    text-align: center;
    margin-top: 2rem;
    font-size: 16px;
  }

  @media (min-width: 992px) {
    margin: 1rem;
  }
`

const StyledButtonDefault = styled(ButtonDefault)`
  font-size: 18px;
`

const AdvantagesCol = styled.div`
  & li,
  p {
    text-align: justify !important;
  }

  & ol {
    margin-top: 2rem;
  }

  & li {
    margin-bottom: 1.5rem;
  }
`

function AdvantagesGrid({ items, description, link }) {
  const firstHalf = items.slice(0, items.length / 2)
  const secondHalf = items.slice(items.length / 2)

  return (
    <Section>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-7">
            <div className="row mr-lg-5">
              {firstHalf.map((edge) => (
                <div className="col-sm-6 mb-4 mb-lg-0">
                  <StyledBoxDefault>
                    <div className="d-flex flex-column justify-content-center h-100">
                      <Plaatjie image={edge.icon} />
                      <span>{edge.title}</span>
                    </div>
                  </StyledBoxDefault>
                </div>
              ))}
            </div>
            <div className="row mt-lg-4 ml-lg-5">
              {secondHalf.map((edge) => (
                <div className="col-sm-6 mb-4 mb-lg-0">
                  <StyledBoxDefault>
                    <div className="d-flex flex-column justify-content-center h-100">
                      <Plaatjie image={edge.icon} />
                      <span>{edge.title}</span>
                    </div>
                  </StyledBoxDefault>
                </div>
              ))}
            </div>
          </div>
          <AdvantagesCol className="col-lg-5 pl-lg-5">
            <ParseContent content={description} />
            <div className="mt-lg-5">
              {link && (
                <StyledButtonDefault to={link.url} target={link.target}>
                  {link.title}
                </StyledButtonDefault>
              )}
            </div>
          </AdvantagesCol>
        </div>
      </div>
    </Section>
  )
}

export default AdvantagesGrid
